import { useState } from "react";
import { toast } from "sonner";
import { Coins, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

// Coach/admin: return 1 credit to a player's account with a reason.
export function ReCreditButton({ studentId, studentName, bookingId = null, onDone, testid = "re-credit" }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (reason.trim().length < 2) { toast.error("Add a short reason"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/coach/students/${studentId}/re-credit`, { reason: reason.trim(), booking_id: bookingId });
      toast.success(`1 credit added to ${studentName || "player"} — they now have ${data.total_remaining}`);
      setOpen(false); setReason(""); onDone?.();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't re-credit"); }
    finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid={testid}
        className="px-2.5 py-1 text-[11px] uppercase tracking-wider font-bold border border-[#66C2FF] text-[#66C2FF] inline-flex items-center gap-1">
        <Coins className="w-3 h-3" /> Re-credit
      </button>
    );
  }
  return (
    <div className="flex flex-wrap items-center justify-end gap-1.5" data-testid={`${testid}-form`}>
      <input autoFocus value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (shown to player)"
        onKeyDown={(e) => e.key === "Enter" && save()}
        className="bg-[#141414] border border-[#262626] px-2 py-1 text-xs focus:outline-none focus:border-[#66C2FF] w-48" data-testid={`${testid}-reason`} />
      <button type="button" onClick={save} disabled={busy} data-testid={`${testid}-save`}
        className="px-2.5 py-1 text-[11px] uppercase tracking-wider font-bold bg-[#66C2FF] text-black inline-flex items-center gap-1 disabled:opacity-50">
        {busy && <Loader2 className="w-3 h-3 animate-spin" />} Add 1 credit
      </button>
      <button type="button" onClick={() => setOpen(false)} className="text-[11px] text-[#A3A3A3] px-1" data-testid={`${testid}-cancel`}>Cancel</button>
    </div>
  );
}
